// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3nBMQ","header":"MergedInvoice_header__yHF_v"};